export default class PickUp {
    constructor(game, x, y, image, type) {
        this.game = game
        this.x = x
        this.y = y
        this.width = 200
        this.height = 157
        this.color = image
        this.type = type
        this.rotation = 0
        this.rotationFrequency = 0.02
        this.scale = 0.25
        this.image = document.getElementById(image)
        this.colisionRadius = this.width * this.scale / 2
        this.collisionOriginX = this.x + this.width * this.scale / 2
        this.collisionOriginY = (this.y + this.height * this.scale) - this.colisionRadius
        this.readyToDestroy = false
        this.missedItem = false
    }
    update(deltaTime) {
        this.x -= this.game.gameSpeed * deltaTime
        this.rotation -= this.rotationFrequency * deltaTime

        if(this.x + this.width < 0) {
            this.readyToDestroy = true
            this.missedItem = true
        }
        this.updateCollisionCircle()
    }
    draw(context) {
        context.globalAlpha = 1
        context.translate(this.x + this.width * this.scale / 2, this.y + this.height * this.scale / 2)
        context.rotate(this.rotation * Math.PI / 180)
        context.translate(-(this.x + this.width * this.scale / 2), -(this.y + this.height * this.scale / 2))
        context.drawImage(this.image, 0, 0, this.width, this.height, this.x, this.y, this.width * this.scale, this.height * this.scale)
        context.setTransform(1, 0, 0, 1, 0, 0)
        //context.strokeStyle = "#000000"
        //context.lineWidth = 3
        //context.beginPath();
        //context.arc(this.collisionOriginX, this.collisionOriginY, this.colisionRadius, 0, 2 * Math.PI);
        //context.stroke();
    }
    updateCollisionCircle() {
        this.colisionRadius = this.width * this.scale / 2
        this.collisionOriginX = this.x + this.width * this.scale / 2
        this.collisionOriginY = (this.y + this.height * this.scale) - this.colisionRadius
    }
}